import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../axiosBaseQuery";


const glacierApi = createApi({
    reducerPath: "core/glacier",
    baseQuery: axiosBaseQuery,
    tagTypes: ["glacierList"],
    endpoints: (builder) => ({
        glacierFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['glacierList'],
            query: (query = '') => ({
                url: "/core/glacier" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        glacierCreate: builder.mutation({
            invalidatesTags: ['glacierList'],
            query: (data) => ({
                url: `/core/glacier`,
                method: "POST",
                data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
        }),
        glacierUpdate: builder.mutation({
            invalidatesTags: ['glacierList'],
            // query: (data)=>({url: "/core/glacier/"+data.id, method: "PUT", data})
            query: (data) => ({
                url: `/core/glacier/${data.get('id')}`,
                method: "PUT",
                data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                } 
            })
        }),

        // console.log(data);

        glacierDelete: builder.mutation({
            invalidatesTags: ['glacierList'],
            query: (id) => ({ url: "/core/glacier/" + id, method: "DELETE" })
        }),
    })
})

export const { useGlacierFindAllQuery, useGlacierCreateMutation, useGlacierUpdateMutation, useGlacierDeleteMutation } = glacierApi;
export { glacierApi };
